<template>
  <Page class="SuplliersPage">
    <IllustrationBanner />

    <div class="container">
      <h2 class="color--primary">{{ $t('suppliersPageHeading') }}</h2>
      <SupplierList :suppliers="suppliers" />
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page.vue';
import IllustrationBanner from '@/components/IllustrationBanner.vue';
import SupplierList from '@/components/supplier/List.vue';

export default {
  name: 'SuppliersPage',
  components: {
    Page,
    IllustrationBanner,
    SupplierList,
  },
  computed: {
    suppliers() {
      return this.$store.state.filter.suppliers;
    },
  },
};
</script>
